import React from "react";

export const ReferralTableHeader = ({
  headOne,
  headTwo,
  headThree,
  headFour,
  headFive,
  headSix,
  headSeven,
  headEight,
  headNine,
  headTen,
}) => {
  return (
    <React.Fragment>
      <tr>
        <th style={{ width: "10%" }}>{headOne}</th>
        <th style={{ width: "15%" }}>{headTwo}</th>
        <th style={{ width: "10%" }}>{headThree}</th>
        <th style={{ width: "10%" }}>{headFour}</th>
        <th style={{ width: "10%" }}>{headFive}</th>
        <th style={{ width: "10%" }}>{headSix}</th>
        <th style={{ width: "8%" }}>{headSeven}</th>
        <th style={{ width: "7%" }}>{headEight}</th>
        <th style={{ width: "10%" }}>{headNine}</th>

        <th style={{ width: "10%" }}>{headTen}</th>
      </tr>
    </React.Fragment>
  );
};
